export { default as timeTemplate } from './time.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/controls/time/templates/index.ts